module.exports = __webpack_public_path__ + "static/assets/0ff4db9010c97c4facbdb1301e29d13a.png";